var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("md-dialog-confirm", {
        attrs: {
          "md-active": _vm.showDialog,
          "md-title": "Are you sure you want to delete this circle?",
          "md-content":
            "Please be aware that once this circle is deleted, all associated data will be permanently removed. This action cannot be undone.",
          "md-confirm-text": "Delete",
          "md-cancel-text": "Cancel"
        },
        on: {
          "update:mdActive": function($event) {
            _vm.showDialog = $event
          },
          "update:md-active": function($event) {
            _vm.showDialog = $event
          },
          "md-cancel": function($event) {
            return _vm.cancel()
          },
          "md-confirm": function($event) {
            return _vm.deleteCircleRow(_vm.circle._id)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "md-button",
        {
          staticClass: "picker-icon picker-name",
          on: {
            click: function($event) {
              _vm.showDialog = true
            }
          }
        },
        [
          _c("font-awesome-icon", {
            staticClass: "small-icon picker-icon-danger",
            attrs: { icon: "minus-circle", "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "delete-circle" }, [
            _vm._v("Remove Circle")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b6ade936", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6ade936","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeleteCircleConfirm.vue
// module id = null
// module chunks = 